import { FragmentSerializer } from "./FragmentSerializer";
import FootballState from "../../../../../sports/football/state/football-state";
import FootballStringifier from "../../../../stringifiers/football-stringifier";

export class SkipKickoffFragmentSerializer extends FragmentSerializer {
    applicable(fragment, play, serializationContext) {
        return fragment.associatedState === FootballState.SkipKickoff;
    }

    getRawFragment(play, serializationContext, fragment) {
        const { summaryContext } =
            FootballStringifier.generateSummary(
                play,
                serializationContext.gameContext
            ) || {};
        const { homeTeamHasPossession } = summaryContext;
        const teamSide = homeTeamHasPossession ? "V" : "H";
        const startDrive =
            serializationContext.gameContext.homeTeamHasPossession !==
            play.contextSnapshot.homeTeamHasPossession
                ? "Y"
                : "N";

        const values = [
            teamSide,
            this.resolveFormattedFieldPosition(
                serializationContext,
                fragment.fieldPosition
            ),
            startDrive
        ];

        return `SPOT:${values.join()}`;
    }
}
